import { usePremium } from "../../../contexts/Premium";
import { Box, SimpleGrid } from "@chakra-ui/react";
import Spinner from "../../../shared/components/Spinner";
import ReadingOrderCard from "../components/ReadingOrderCard";

const SearchResults = ({ results, isLoading, searchTerm }) => {
  const { isPremium } = usePremium();
  return (
    <Box>
      {isLoading && <Spinner />}
      {results && results.length > 0 ? (
        <p>
          <SimpleGrid columns={[1, 2, 2, 2]} spacing="16px">
            {results.map((readingOrder) => {
              const premiumOnly = Boolean(
                readingOrder.paywallPremiumOnly ?? readingOrder.premiumOnly
              );

              return (
                <ReadingOrderCard
                  key={readingOrder.id}
                  id={readingOrder.id}
                  title={readingOrder.title}
                  thumbnail={readingOrder.thumbnail}
                  comicsCount={readingOrder.comicsCount}
                  readersCount={
                    readingOrder.readersCount ?? readingOrder.readingCount
                  }
                  years={readingOrder.years}
                  author={readingOrder.author}
                  readingCount={readingOrder.readingCount}
                  premiumOnly={premiumOnly}
                  isPremium={isPremium}
                  isBookClub={Boolean(readingOrder.bookClub)}
                  hideStartAction
                />
              );
            })}
          </SimpleGrid>
        </p>
      ) : (
        <p>No results found for "{searchTerm}"</p>
      )}
    </Box>
  );
};

export default SearchResults;
